export default __webpack_public_path__ + "static/media/Resource-Icons-Social-Emotional-transparent.f4c53398.png";